import dayjs from 'dayjs';

function getDateDifference(start: string, end: string): string {
    return dayjs(start).to(end, true);
}

export default getDateDifference;
